// extracted by mini-css-extract-plugin
export default {"Ripple":"SpinnerLoader_Ripple__9VYDi","AnimateRipple":"SpinnerLoader_AnimateRipple__1mKOn"};